/**
 * v2 Theme - Radius
 */
const radius = {
  button: 8,
  card: 12,
  input: 8,
  chip: 999,
};

export default radius;

